import '../css/resources.css';

import React, { useState, useRef, useEffect } from 'react';
import { PublicFooter, PublicTitle, PublicNavbar } from "../components/pagestyle.js";
import { ParticleBackground } from '../components/pagestyle.js';

// import { HomeCardTemplate } from './home';
// import { useNavigate, Route, Routes, useLocation } from "react-router-dom";
import { Tooltip } from 'react-tooltip';

// import { HomePageChatOnly, HomeCardsSection } from './home';

import { useLocation, useNavigate } from 'react-router-dom'; // Add these imports



function EnterEmailModal() {
    const [email, setEmail] = useState("");
    const [first, setFirst] = useState("");
    const [last, setLast] = useState("");
    const [response, setResponse] = useState("");

    let handleSubmitGeneral = async (e) => {
        e.preventDefault();
        handleSubmit("feedback");
    }

    async function handleSubmit() {
        if (!email) {
            setResponse("Email required to submit");
            return;
        }
        if (!first) {
            setResponse("First Name required to submit");
            return;
        }
        if (!last) {
            setResponse("Last Name required to submit");
            return;
        }
        const validateEmail = (em) => {
            return String(em)
                .toLowerCase().match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                );
        };
        if (email && !validateEmail(email)) {
            setResponse("Valid email required to submit");
            return;
        }
        /*let token = captchaRef.current.getValue();
        if (!token) {
            setResponse("Recaptcha required to submit");
            return;
        }*/
        window.dataLayer.push({ 'event': 'resource_center_email_access' });
        try {
            let res = await fetch(`/api/public/request-pdf`, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: email,
                    first: first,
                    last: last,
                    url: window.location.href,
                    //captcha: token
                }),
            });
            //captchaRef.current.reset();
            if (res.status === 200) {
                setEmail("");
                setFirst("");
                setLast("");
                setResponse("Attachments of the requested documents will be sent to your email");
            } else if (res.status === 403 || res.status === "403") {
                setResponse("Error: please try again or contact us directly");
            } else {
                setResponse("Some error occurred");
            }
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <div className="home-chat-modal">
            <h3>Enter Email to Receive fAlpha Documentation</h3>
            <form className="home-modal-form">
                <input type="text" value={email} id="email" onChange={(e) => setEmail(e.target.value)} placeholder={"Business Email"} />
                <input type="text" value={first} id="first" onChange={(e) => setFirst(e.target.value)} placeholder={"First Name"} />
                <input type="text" value={last} id="last" onChange={(e) => setLast(e.target.value)} placeholder={"Last Name"} />
                {/*<div className="home-onboarding-recaptcha">{recaptchaSiteKey ? <ReCAPTCHA sitekey={recaptchaSiteKey} ref={captchaRef} /> : null}</div>*/}
                <button onClick={handleSubmitGeneral}>Submit</button>
                <div className="message">{response ? <p>{response}</p> : null}</div>
            </form>
        </div>
    );
}

/* Small Card Explanations */


function HomeCardTemplate(props) {
    const [cardState, setCardState] = useState(false);
    const pRef = useRef(null);

    const Trigger = () => {
        if (!cardState){
            setCardState(true);
            pRef.current.style.height = 'fit-content';
        } else {
            setCardState(false);
            pRef.current.style.height = '60px';
        }
    }
    useEffect(() => {
        if (props.triggered) {
            pRef.current.style.height = 'fit-content';
        }
    }, []);

    return (
        <div className="small-card" onClick={Trigger}>
            <h3 className="small-card-h3">{props.title}</h3>
            <p ref={pRef} className="small-card-p">{props.shown} {props.hidden}</p>
            {props.triggered || cardState ? null : <button onClick={Trigger} style={{ border: "none" }}>Learn more</button>}
            {props.icon ? <img style={{ display: "flex", padding: "10px", alignItems: "center", width: "40px" }} src={props.icon} /> : null}
        </div>
    )
}



function HomeCardsSection() {
    return (
        <div className="home-card-container">
            <HomeCardTemplate
                title="A New Way for Worldclass Traders"
                shown="Traders have always needed unique, quantifiable, and reliable alpha to succeed. But with digital sources the game has gotten tougher."
                hidden="Alpha uniqueness is key even in non-zero-sum game market situations. It must allow traders to generate profits not easily replicated by others. On the other hand, risk management is about quantifying and acting in markets. This requires having sound and flexible statistical models. But that is not enough, data reliability is essential. Traders need to be able to trust their data. That is, traders should not use black boxes. Instead they should only rely on data that is verifiable and transparent. Doing this with outside data providers is revolutionary especially in this day of generative AI."
            />
            <HomeCardTemplate
                title="Quantifiable and Verifiable Alpha"
                shown="Quantification and verification are two sides of the same coin. fAlpha constantly calculates trading signals, confidence levels of its large sets of data, then it backtests its statistical summaries (ex ante and ex post)."
                hidden="And, to make YOU (the data user) comfortable and confident, fAlpha releases the performance of its statistical predictions. Its sources and historical sets are not only made available to YOU, they are intrinsic to fAlpha's ongoing product. This keeps us focused on our truth telling mission. That is, fAlpha goes beyond a “we stand by our data” rhetoric. We even guarantee some users' with their money back (depending the account settings). "
            />
            <HomeCardTemplate
                title="Traders and Analysts Use Cases"
                shown="Risk takers and analysts focused on corporate names use fAlpha's platform and/or its PRA to make more accurate, faster and reliable decisions. In a few seconds they gain insights on potentially hidden digital data."
                hidden="Traders get buy/sell signals, associated confidence levels, and various sentiment dimensions current and historical. For instance, they can check current and historical risk metrics, and accurately perform what if analyses. They can also create relative value groups, and get insights about corporates with similar behaviors. Analysts can also download and check historical data sets. They can mix those with their own other time series and even train their models with fAlpha's sentiment scores. Both traders and analysts can keep their stakeholders easily and automatically in the loop."
            />
            <HomeCardTemplate
                title="Context and Investment Signals"
                shown="Markets can move mostly in one direction but even in those cases some names lag. While there is always a reason time is of the essence. And since it is about YOUR alpha. YOUR concerns may differ from others."
                hidden="For instance, you may want to optimize some macro economic factor or view. fAlpha machines help you spot checking historical results. Its proprietary indicators identify market opportunities that are imperceptible to the naked eye. Plus it makes it easy for your eyes only. fAlpha helps you get ahead of the market and make smarter investment decisions right away."
            />
            <HomeCardTemplate
                title="How  Uses AI and LLMs"
                shown="fAlpha uses backpropagation to train several of its signals, it also uses large language models (LLMs) to communicate with its proprietary database."
                hidden="However, fAlpha is not a generative AI tech company, so it does not run the risk of producing unverifiable data or hallucinations around its signals. fAlpha delivers its data through a variety of forms, including a dashboard, a mobile app, an API, and Simple Storage Service (S3)."
            />
            <HomeCardTemplate
                title="Why fAlpha"
                shown="fAlpha was founded to help bring operational efficiencies to the corporate trading markets. Some of its founders lived through those inefficiencies (as users and producers) and know fixing is within reach."
                hidden="fAlpha's goal is to reduce market noise, especially in the one associated with digital data sets. More than being confident about its data and models, fAlpha is accountable to it outcomes. Regardless if the outcomes agree with fAlpha's initial predictions it displays them.  fAlpha will even issue partial refunds when the overall statistical results are off. There are reasons for fAlpha to be trusted by world-renowned institutions. Request special access through our contact form above."
            />
        </div>
    );
}

/* Insider class components are inside the cards' pop ups */


function WhyUsInsider() {
    return (
        <>
            <HomeCardsSection />
            <HomeCardsSection />
            <HomeCardsSection />
            <HomeCardsSection />
        </>
    )
}

function StepByStepInsider() {
    return (
        <>
            <img alt="" src="/images/home-page-cycle-3-no-bam.svg" width="100%" style={{ borderRadius: "25px"}} />
        </>
    )
}


function FlipCard({ frontContent, backContent }) {
    const [isFlipped, setIsFlipped] = useState(false);
  
    const handleCardClick = () => {
      setIsFlipped(!isFlipped);
    };
  
    return (
      <div
        className={`flip-card-container ${isFlipped ? 'flipped' : ''}`}
        onClick={handleCardClick}
      >
        <div className="flip-card-inner">
          <div className="flip-card-front">
            {frontContent}
          </div>
  
          <div className="flip-card-back">
            {backContent}
          </div>
        </div>
      </div>
    );
  }

function GetStartedInsider() {
    const [pageState, setPageState] = useState(null);

    return (
        <>
            <h2 style={{ color: "#4c6681" }}>Start with 3 Core Ones to Choose From</h2>
            <div style={{ display: "flex", margin: "auto" }}>
                <FlipCard
                    frontContent={
                    <>
                        <img alt="" src="images/how-it-works-1.png" style={{ width: "40%", margin: "10%" }} />
                        <h1>Focus on Pressing Matters</h1>
                        <p>Data insights help you target corporations primed for price action</p>
                    </>
                    }
                    backContent={
                    <>
                        <p>1 .Key metrics needed to quickly make or support decisions. AI driven signal based on your customized needs and views.</p>
                        <p>2. Agree or disagree with the signal, and see how your opinion compares with top analysts (over 3k of them).</p>
                        <p>3. View detailed analyses. Which strategies are better recommended? What history has to say about this signal?</p>
                    </>
                    }
                />
                <FlipCard
                    frontContent={
                    <>
                        <img alt="" src="images/how-it-works-2.png" style={{ width: "40%", margin: "10%" }} />
                        <h1>Find Relative Value</h1>
                        <p>Companies ranked by future performance, risk scenarios, and strategies</p>
                    </>
                    }
                    backContent={
                    <>
                        <p>1. Find the corporates with the strongest signals. Filter by names, indices, sectors, etc</p>
                        <p>2. The column gives you the equity or credit with the most relevant  names based on current dynamics</p>
                        <p>3. You can further view clustered names by clicking on the Relative Value field and seeing company lists machine ranked</p>
                    </>
                    }
                />
                <FlipCard
                    frontContent={
                    <>
                        <img alt="" src="images/how-it-works-3.png" style={{ width: "40%", margin: "10%" }} />
                        <h1>Find Hedges, Optimal Baskets</h1>
                        <p>Compare ETFs and portfolios or new reccomendations. Discover optimal hedges</p>
                    </>
                    }
                    backContent={
                    <>
                        <p>1. Find the corporates with the strongest signals. Filter by names, indices, sectors, etc</p>
                        <p>2. See optimal and natural hedges. Check those companies to deepen your research</p>
                        <p>3. Use our information to make informed decisions about your trades, giving you the quantitative analysis you need at a moments notice</p>
                    </>
                    }
                />
            </div>
        </>
    )
}

function GoLiveInsider() {
    return (
        <>
                <div style={{position: "relative", width: "100%"}}>
                    <img alt="" src="images/tradingpulse-example.png" width="100%" className="truecolor" style= {{borderRadius: "25px"}}/>
                <div 
                    style={{top: "7%", left: "1%", height: "6%", width: "53%", position: "absolute", border: "1px solid #1976d2", backgroundColor: "rgba(25, 118, 210, .2)", borderRadius: "10px"}}
                    data-tooltip-id="how-it-works-tooltip"
                    data-tooltip-html="<p style='max-width: 40vw'>Search by stock ticker, CUSIP, or debtor name, and filter based on index membership or sector</p>"
                />
                <div 
                    style={{top: "17%", left: "0%", height: "9%", width: "4.3%", position: "absolute", border: "1px solid #1976d2", backgroundColor: "rgba(25, 118, 210, .2)", borderRadius: "10px"}}
                    data-tooltip-id="how-it-works-tooltip"
                    data-tooltip-html="<p style='max-width: 40vw'>Select your favorites by clicking the star under Actions and toggle here to view</p>"
                />
                <div 
                    style={{top: "17%", left: "4.7%", height: "9%", width: "3%", position: "absolute", border: "1px solid #1976d2", backgroundColor: "rgba(25, 118, 210, .2)", borderRadius: "10px"}}
                    data-tooltip-id="how-it-works-tooltip"
                    data-tooltip-html="<p style='max-width: 40vw'>ETF predictions are average weighted by confidences and constituent company participation in the ETF.</p>"
                />
                <div 
                    style={{top: "15%", left: "14%", height: "13%", width: "49%", position: "absolute", border: "1px solid #1976d2", backgroundColor: "rgba(25, 118, 210, .2)", borderRadius: "10px"}}
                    data-tooltip-id="how-it-works-tooltip"
                    data-tooltip-html="<p style='max-width: 40vw'><strong>Displays the overall PnL of all companies filtered</strong> based off of the specific search result. This is calculated with an even weight on each company, no matter its market size.</p>"
                />
                <div 
                    style={{top: "13%", left: "68%", height: "17%", width: "9%", position: "absolute", border: "1px solid #1976d2", backgroundColor: "rgba(25, 118, 210, .2)", borderRadius: "10px"}}
                    data-tooltip-id="how-it-works-tooltip"
                    data-tooltip-html="<p style='max-width: 40vw'><strong>You can choose a market regime - </strong>your index prediction-to get signals tailored to your macro strategy</p>"
                />
                <div 
                    style={{top: "14%", left: "79.6%", height: "15.5%", width: "19.5%", position: "absolute", border: "1px solid #1976d2", backgroundColor: "rgba(25, 118, 210, .2)", borderRadius: "10px"}}
                    data-tooltip-id="how-it-works-tooltip"
                    data-tooltip-html="<p style='max-width: 40vw'><strong>Displays the best forward looking trades</strong> based on last day's price movements and our signals </p>"
                />
                <div 
                    style={{top: "32%", left: ".5%", height: "9%", width: "13%", position: "absolute", border: "1px solid #1976d2", backgroundColor: "rgba(25, 118, 210, .2)", borderRadius: "10px"}}
                    data-tooltip-id="how-it-works-tooltip"
                    data-tooltip-html="<p style='max-width: 40vw'>Company Name and Stock Ticker.</p>"
                />
                <div 
                    style={{top: "42%", left: ".5%", height: "7%", width: "13%", position: "absolute", border: "1px solid #1976d2", backgroundColor: "rgba(25, 118, 210, .2)", borderRadius: "10px"}}
                    data-tooltip-id="how-it-works-tooltip"
                    data-tooltip-html="<p style='max-width: 40vw'>Click here to get an in depth look at this company (heat maps, etc)</p>"
                />
                <div 
                    style={{top: "32%", left: "14.5%", height: "9%", width: "17%", position: "absolute", border: "1px solid #1976d2", backgroundColor: "rgba(25, 118, 210, .2)", borderRadius: "10px"}}
                    data-tooltip-id="how-it-works-tooltip"
                    data-tooltip-html="<p style='max-width: 40vw'><strong>Select your anticipated hold period-</strong> to see the trading indicator (Equity/EI or Credit/CI). <br />The chart shows the company's performance relative to it's relevant index over a that hold period</p>"
                />
                <div 
                    style={{top: "42%", left: "26%", height: "7%", width: "2.5%", position: "absolute", border: "1px solid #1976d2", backgroundColor: "rgba(25, 118, 210, .2)", borderRadius: "10px"}}
                    data-tooltip-id="how-it-works-tooltip"
                    data-tooltip-html="<p style='max-width: 40vw'>Click the light bulb.<br />Be surprised! This displays which analysts agree with you or fAlpha</p>"
                />
                <div 
                    style={{top: "32%", left: "33%", height: "9%", width: "22%", position: "absolute", border: "1px solid #1976d2", backgroundColor: "rgba(25, 118, 210, .2)", borderRadius: "10px"}}
                    data-tooltip-id="how-it-works-tooltip"
                    data-tooltip-html="<p style='max-width: 40vw'>Select a historical time horizon to see from the drop down choices:<ul><li><strong>Historical Active PnL-</strong> Profit & Loss resulting from trades executed based on signals</li><li><strong>Insider & Sentiment-</strong> Sentiment Scores on relevant Digital Media </li><li><strong>News Flow-</strong> Volume of news relative to itself over 30 days</li></ul></p>"
                />
                <div 
                    style={{top: "42%", left: "33%", height: "7%", width: "22%", position: "absolute", border: "1px solid #1976d2", backgroundColor: "rgba(25, 118, 210, .2)", borderRadius: "10px"}}
                    data-tooltip-id="how-it-works-tooltip"
                    data-tooltip-html="<p style='max-width: 40vw'>View of whatever chart you select over the given time horizon. </p>"
                />
                <div 
                    style={{top: "32%", left: "56%", height: "9%", width: "15.5%", position: "absolute", border: "1px solid #1976d2", backgroundColor: "rgba(25, 118, 210, .2)", borderRadius: "10px"}}
                    data-tooltip-id="how-it-works-tooltip"
                    data-tooltip-html="<p style='max-width: 40vw'>Select from the drop down choices: <ul><li><strong>Risk Metrics-</strong> Value at risk, Expected Shortfall, Peek-to-Trough</li><li><strong>Sharpe Ratio-</strong> Passive and Active</li> </ul></p>"
                />
                <div 
                    style={{top: "42%", left: "56%", height: "7%", width: "15.5%", position: "absolute", border: "1px solid #1976d2", backgroundColor: "rgba(25, 118, 210, .2)", borderRadius: "10px"}}
                    data-tooltip-id="how-it-works-tooltip"
                    data-tooltip-html="<p style='max-width: 40vw'>View the metrics selected in the above column</p>"
                />
                <div 
                    style={{top: "32%", left: "73%", height: "9%", width: "15.5%", position: "absolute", border: "1px solid #1976d2", backgroundColor: "rgba(25, 118, 210, .2)", borderRadius: "10px"}}
                    data-tooltip-id="how-it-works-tooltip"
                    data-tooltip-html="<p style='max-width: 40vw'>Select from the drop down choices:<ul><li><strong>Similar Companies-</strong> companies with similar market or fundamental ratios to the target</li><li><strong>Relative Value-</strong> Based on the most similar companies that presents the highest confidence will move the opposite direction</li></ul></p>"
                />
                <div 
                    style={{top: "42%", left: "73%", height: "7%", width: "15.5%", position: "absolute", border: "1px solid #1976d2", backgroundColor: "rgba(25, 118, 210, .2)", borderRadius: "10px"}}
                    data-tooltip-id="how-it-works-tooltip"
                    data-tooltip-html="<p style='max-width: 40vw'>View Similar Companies or Relative Value shown here </p>"
                />
                <div 
                    style={{top: "32%", left: "89.5%", height: "9%", width: "10%", position: "absolute", border: "1px solid #1976d2", backgroundColor: "rgba(25, 118, 210, .2)", borderRadius: "10px"}}
                    data-tooltip-id="how-it-works-tooltip"
                    data-tooltip-html="<p style='max-width: 40vw'>Select favorite companies, create email notifications, download rich and customizable reports or historical data</p>"
                />
                <div 
                    style={{top: "42%", left: "89.5%", height: "7%", width: "10%", position: "absolute", border: "1px solid #1976d2", backgroundColor: "rgba(25, 118, 210, .2)", borderRadius: "10px"}}
                    data-tooltip-id="how-it-works-tooltip"
                    data-tooltip-html="<p style='max-width: 40vw'>Icons to favorite (star), create email alerts (bell), reports (book) download data.</p>"
                />
            </div>
            <Tooltip id="how-it-works-tooltip" multiline={true} data-html={true} style={{ zIndex: "105", backgroundColor: "#1976d2", color: "var(--light-font)", boxShadow: "0 0 5px #D9D9D9" }} />
            <p>Hover to See How Tradingpulse Works</p>
        </>
    )
}

function LearnMoreInsider(props){

    function handleOpenPDF(type = "") {
        window.dataLayer.push({ 'event': 'resource_center_open_pdf' });
        window.location.href = `/api/public/pdf-documents?type=${type}`;
    }

    const propsdisabled = false;

    return (
        <>
        <div className="home-card-container"> {/* style = {{ marginLeft: "100px", marginRight: "100px" }}> */}
            <button onClick={propsdisabled ? null : (() => handleOpenPDF("onepager"))} className="escape-button">
                <HomeCardTemplate
                    title="A Wealth of Signals at Arm's Reach"
                    shown="Learn more about Tradingpulse: fAlpha's source of thousands of signals, insights, and more."
                    icon="images/icons/file-pdf.svg"
                    triggered
                />
            </button>
            <button onClick={propsdisabled ? null : (() => handleOpenPDF("brief"))} className="escape-button">
                <HomeCardTemplate
                    title="Solution Brief: Elevated Trading Intelligence"
                    shown="Learn more about how fAlpha is working to make the extensive and complex world of financial data accessible to everyone."
                    icon="images/icons/file-pdf.svg"
                    triggered
                />
            </button>
            <button onClick={propsdisabled ? null : (() => handleOpenPDF("historical"))} className="escape-button">
                <HomeCardTemplate
                    title="Historical Performance Charts with Adaptive Signals"
                    shown="Explore historical performance with clear charts that showcase returns when trades are executed and unwound using fAlpha's proprietary LSTM model."
                    icon="images/icons/file-pdf.svg"
                    triggered
                />
            </button>
            <button onClick={propsdisabled ? null : (() => handleOpenPDF("infographic"))} className="escape-button">
                <HomeCardTemplate
                    title="Our Advanced LSTM Model"
                    shown="Learn more about how fAlpha has leveraged AI to build a model which surpasses traditional financial models"
                    icon="images/icons/file-pdf.svg"
                    triggered
                />
            </button>
        </div>
        </>
    )
}




function Card({ title, icon, Insider, id }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    // Store the position of the clicked card
    const [cardRect, setCardRect] = useState(null);
    const cardRef = useRef(null);         // Ref for the card itself
    const modalContentRef = useRef(null); // Ref for the modal content for the animation class
  
    const location = useLocation();
    const navigate = useNavigate();

    const openModal = () => {
      if (cardRef.current) {
        setCardRect(cardRef.current.getBoundingClientRect());
        navigate(`#opencard-${id}`, { replace: true });
      }
      setIsModalOpen(true);
    };
  
    const closeModal = () => {
      setIsModalOpen(false);
      if (location.hash === `#opencard-${id}`) {
        navigate(location.pathname, { replace: true }); // Navigate to same path, no hash
      }
    };
  
    useEffect(() => {
      if (isModalOpen && modalContentRef.current) {
        setTimeout(() => {
          modalContentRef.current.classList.add('open');
        }, 50);
      } else if (modalContentRef.current) {
        modalContentRef.current.classList.remove('open');
      }
    }, [isModalOpen]);

    useEffect(() => {
        if (location.hash === `#opencard-${id}`) {
          setIsModalOpen(true);
        }
        else {
          setIsModalOpen(false);
        }
      }, [location.hash, id]);
  
    // Calculate modal content's initial transform origin and position
    const modalStyles = {};
    if (cardRect) {
      // Calculate the center of the card relative to the viewport
      const cardCenterX = cardRect.left + cardRect.width / 2 - 300;
      const cardCenterY = cardRect.top + cardRect.height / 2;
  
      // Translate the modal content from the card's center to the viewport center
      // when it's closed (scale 0). This is applied to the modal-content.
      modalStyles.transformOrigin = `${cardCenterX}px ${cardCenterY}px`;
      // Since the modal-content is positioned by flexbox, we don't directly translate it here
      // The `transform-origin` is enough for the scaling effect to come from the card.
      // If you needed to move the entire modal-content, you would calculate translateX/Y
      // based on the difference between card center and modal's desired center.
      // For a simple scale-from-card-center, `transform-origin` is the key.
    }
  
    return (
      <>
        <div className="card">
          <div className="card-inner" onClick={openModal} ref={cardRef}>
            <div className="card-inner-shadow"></div>
            <div className="card-title">{title}</div>
            <div className="card-content">
                <img src={icon} className="card-icon" />
            </div>
          </div>
        </div>
  
        {isModalOpen && (
          <div className="modal-overlay" onClick={closeModal}>
            <div
              className="modal-content"
              ref={modalContentRef}
              style={modalStyles} // Apply the calculated style here
              onClick={(e) => e.stopPropagation()}
            >
              <button className="modal-close-button" onClick={closeModal}>
                &times;
              </button>
              <div className="modal-scrollable-content"><Insider/></div>
            </div>
          </div>
        )}
      </>
    );
}
 

// Main Product component
export default function Product() {
  return (
    <div className="page">
      <div className="particle-background">
          <ParticleBackground />
      </div>
      <PublicNavbar />
      <div class="container">
          <div class="question">What do you want to <span class="design-word">know</span> about?</div>
          <div class="tagline">Customizable AI-Powered Trading Edge for Investment Managers</div>
      </div>
      <div className="cards-container">
        <Card id="1" title="Some use cases" icon="images/icons/circle-play.svg" Insider={GetStartedInsider} />
        <Card id="2" title="Why Choose Us?" icon="images/icons/circle-question.svg" Insider={WhyUsInsider} />
        <Card id="3" title="Walking through Tradingpulse" icon="images/icons/chart.svg" Insider={GoLiveInsider} />
        <Card id="4" title="High level steps" icon="images/icons/gear.svg" Insider={StepByStepInsider} />
        <Card id="5" title="Learn More..." icon="images/icons/file-pdf.svg" Insider={LearnMoreInsider} />
      </div>
    </div>
  );
}